export default __webpack_public_path__ + "static/media/brf_cor.e4d37756.png";